import { render, staticRenderFns } from "./RefusalPage.vue?vue&type=template&id=609d1b9f&scoped=true"
import script from "./RefusalPage.vue?vue&type=script&lang=js"
export * from "./RefusalPage.vue?vue&type=script&lang=js"
import style0 from "./RefusalPage.vue?vue&type=style&index=0&id=609d1b9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d1b9f",
  null
  
)

export default component.exports